var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIncserveAdminLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.252 2.16321L5.01624 0.302734V14.1012L9.48273 13.5585L10.1899 15.3027L11.9393 13.0934L15.252 12.6671V2.16321Z",
    fill: "#F6F7FB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.68123 2.04695L0.251953 1.19423V13.171L4.68123 12.4733V2.04695Z",
    fill: "#12B6BC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.54541 5.56417C9.54541 5.41978 9.65781 5.30273 9.79647 5.30273H11.4619C11.6005 5.30273 11.7129 5.41978 11.7129 5.56417V6.19588C11.7129 6.34027 11.6005 6.45732 11.4619 6.45732H9.79647C9.65781 6.45732 9.54541 6.34027 9.54541 6.19588V5.56417Z",
    stroke: "#133F7D",
    strokeWidth: 0.1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.71063 6.515C9.73273 6.46166 9.71063 6.456 9.6853 6.43038L10.174 6.45785C10.1353 6.45949 10.1197 6.46154 10.0906 6.47983L9.62303 6.78757C9.57749 6.8045 9.56314 6.76168 9.5787 6.73702L9.71063 6.515Z",
    stroke: "#133F7D",
    strokeWidth: 0.1
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.32205 5.64844H8.75195C8.19967 5.64844 7.75195 6.09615 7.75195 6.64844V7.65568C7.75195 8.20796 8.19967 8.65568 8.75195 8.65568H9.93887M11.9435 5.64844V5.64844C12.1139 5.64844 12.252 5.78652 12.252 5.95685V8.64428C12.252 8.71497 12.1946 8.77228 12.124 8.77228V8.77228",
    stroke: "#133F7D",
    strokeWidth: 0.1
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6968 7.36C11.6968 7.71652 11.4198 8.00204 11.0823 8.00204C10.7448 8.00204 10.4677 7.71652 10.4677 7.36C10.4677 7.00349 10.7448 6.71797 11.0823 6.71797C11.4198 6.71797 11.6968 7.00349 11.6968 7.36Z",
    stroke: "#133F7D",
    strokeWidth: 0.1
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1137 5.88096C10.1137 5.91898 10.0846 5.9463 10.0529 5.9463C10.0212 5.9463 9.99214 5.91898 9.99214 5.88096C9.99214 5.84295 10.0212 5.81563 10.0529 5.81563C10.0846 5.81563 10.1137 5.84295 10.1137 5.88096Z",
    fill: "white",
    stroke: "#133F7D",
    strokeWidth: 0.1
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6891 5.88096C10.6891 5.91898 10.66 5.9463 10.6283 5.9463C10.5967 5.9463 10.5676 5.91898 10.5676 5.88096C10.5676 5.84295 10.5967 5.81563 10.6283 5.81563C10.66 5.81563 10.6891 5.84295 10.6891 5.88096Z",
    fill: "white",
    stroke: "#133F7D",
    strokeWidth: 0.1
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2667 5.88096C11.2667 5.91898 11.2376 5.9463 11.206 5.9463C11.1743 5.9463 11.1452 5.91898 11.1452 5.88096C11.1452 5.84295 11.1743 5.81563 11.206 5.81563C11.2376 5.81563 11.2667 5.84295 11.2667 5.88096Z",
    fill: "white",
    stroke: "#133F7D",
    strokeWidth: 0.1
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M9.20522 6.75042C9.20522 6.97953 9.02736 7.16178 8.81218 7.16178C8.597 7.16178 8.41914 6.97953 8.41914 6.75042C8.41914 6.5213 8.597 6.33906 8.81218 6.33906C9.02736 6.33906 9.20522 6.5213 9.20522 6.75042Z",
    stroke: "#133F7D",
    strokeWidth: 0.1
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2314 9.06546C10.2314 8.59525 10.6126 8.21406 11.0828 8.21406C11.553 8.21406 11.9342 8.59525 11.9342 9.06546V9.33979C11.9342 9.43562 11.8565 9.51331 11.7607 9.51331H10.4049C10.3091 9.51331 10.2314 9.43562 10.2314 9.33979V9.06546Z",
    stroke: "#133F7D",
    strokeWidth: 0.1
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M8.20259 7.95631C8.20259 7.61973 8.47544 7.34688 8.81202 7.34688C9.1486 7.34688 9.42145 7.61973 9.42145 7.95631V8.12074C9.42145 8.19587 9.36055 8.25678 9.28542 8.25678H8.33862C8.26349 8.25678 8.20259 8.19587 8.20259 8.12074V7.95631Z",
    stroke: "#133F7D",
    strokeWidth: 0.1
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M9.00925 9.11892L8.96393 9.09778L9.00925 9.11892C9.01037 9.11652 9.01327 9.11203 9.02718 9.10815C9.04183 9.10407 9.0609 9.10299 9.08319 9.10299H9.15867C9.23934 9.10299 9.35377 9.09323 9.41609 9.00253C9.42596 8.98817 9.43622 8.97169 9.44729 8.95268L9.44729 8.95268L9.44792 8.95168L9.44932 8.94924L9.45199 8.94458C9.45392 8.94126 9.45628 8.93739 9.4591 8.93333C9.4676 8.92112 9.488 8.91328 9.53112 8.91328H9.70145C9.78248 8.91328 9.84816 8.97896 9.84816 9.05999C9.84816 9.14101 9.78248 9.2067 9.70145 9.2067H9.0565C9.02783 9.2067 9.00459 9.18346 9.00459 9.15479C9.00459 9.13698 9.00571 9.12743 9.00847 9.12071L9.00925 9.11892Z",
    fill: "white",
    stroke: "#133F7D",
    strokeWidth: 0.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncserveAdminLogo);
export default __webpack_public_path__ + "static/media/incserve-admin-logo.969eb47250345b4d63e6167a4d333faa.svg";
export { ForwardRef as ReactComponent };